import React, { useEffect, useState } from 'react';
import axios from "../../../axios"
const ContestWithDrawHistory = () => {

    const [withamount,setWithamount]=useState([])
    useEffect(()=>{

        const fetchData=()=>{
       axios.get(`getContestWithdrawalHistory`)
       .then((res)=>{
         
         setWithamount(res?.data?.result?.withdrawalRecords)
        //  console.log(res?.data?.result)
        
       })
       .catch((err)=>console.log(err))
        }
       fetchData()
         },[])

         console.log(withamount)
  return (
    <div className="lg:py-12">
      <div className="mx-auto mt-8 max-w-screen-lg px-2">
        <div className="sm:flex sm:items-center sm:justify-between flex-col sm:flex-row">
          <p className="flex-1 text-base font-extrabold text-bgBlue text-xl">Contest Withdraw History</p>

          <div className="mt-4 sm:mt-0">
            <div className="flex items-center justify-start sm:justify-end">
              {/* <div className="flex items-center">
                <label htmlFor="sort-by" className="mr-2 flex-shrink-0 text-sm font-medium text-gray-900">
                  Sort by:
                </label>
                <select
                  name="sort-by"
                  className="block w-full whitespace-pre rounded-lg border p-1 pr-10 text-base outline-none focus:shadow sm:text-sm sm:mr-4"
                >
                  <option className="whitespace-no-wrap text-sm">Recent</option>
                </select>
              </div> */}

              {/* <button
                type="button"
                className="inline-flex cursor-pointer items-center rounded-lg border border-gray-400 bg-white py-2 px-3 text-center text-sm font-medium text-gray-800 shadow hover:bg-gray-100 focus:shadow"
              >
                <svg
                  className="mr-1 h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                Export to CSV
              </button> */}
            </div>
          </div>
        </div>

        <div className="mt-6 overflow-hidden rounded-xl border shadow bg-bgBlue">
            {
                withamount&&withamount?.map((e)=>(

                    <table className="min-w-full border-separate border-spacing-y-2 border-spacing-x-2">
                    <thead className="hidden border-b lg:table-header-group">
                      <tr>
                        <td  className="whitespace-normal py-4 text-lg font-medium text-gray-100 sm:px-6">
                          Order Id
                        </td>
                        <td className="whitespace-normal py-4 text-lg font-medium text-gray-100 sm:px-6">Date</td>
                        <td className="whitespace-normal py-4 text-lg font-medium text-gray-100 sm:px-6">Amount</td>
                        <td className="whitespace-normal py-4 text-lg font-medium text-gray-100 sm:px-6">Status</td>
                      </tr>
                    </thead>
        
                    <tbody className="lg:border-gray-300">
                      <tr>
                        <td  className="whitespace-no-wrap py-4 text-sm font-bold text-white sm:px-6">
                         Id- {e?._id.slice(0, e._id.length / 2)}...
                          <div className="mt-1 lg:hidden">
                            <p className="font-normal text-gray-500">{e?.formatedDate}</p>
                          </div>
                        </td>
                        <td className="whitespace-no-wrap hidden py-4 text-sm font-normal text-white sm:px-6 lg:table-cell">
                         {e?.formatedDate}
                        </td>
                        <td className="whitespace-no-wrap py-4 px-2  text-lg text-white  ">
                            <span className='text-center ml-12 lg:ml-0'> {e?.amount} credits</span>
                         
                          <div className={`flex mt-2 ml-auto w-fit items-center rounded-full py-2 px-3  text-md font-medium text-white lg:hidden
                        ${e.status === 'pending' ? 'bg-purple' : e.status === 'completed' ? 'bg-green-500' : 'bg-blue-600'}`}>
                            {e?.status}
                          </div>
                        </td>
                        <td className="whitespace-no-wrap hidden py-4 text-sm font-normal text-bgBlue sm:px-6 lg:table-cell">
                          <div className={`inline-flex items-center rounded-full py-2 px-3 text-md text-white 
                        ${e.status === 'pending' ? 'bg-purple' : e.status === 'completed' ? 'bg-green-500' : 'bg-blue-600'}`}>
                          {e?.status}
                          </div>
                        </td>
                      </tr>
                      <hr />
                    </tbody>
                  </table>
                    ))
            }
         
        </div>
      </div>
    </div>
  );
};

export default ContestWithDrawHistory;
